var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "att-panel" }, [
    _c("div", { staticClass: "card-body p-0" }, [
      _c("div", { staticClass: "att-header" }, [
        _c("span", { staticClass: "att-title capitalize" }, [
          _vm._v(_vm._s(_vm.attributesName)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "att-header-actions" }, [
          _c(
            "button",
            {
              staticClass: "att-icon-btn",
              attrs: {
                id: "minOrMaxAttributeElement",
                type: "button",
                title: _vm.attributesMinimized
                  ? "Maximize Attributes"
                  : "Minimize Attributes",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    _vm.attributesMinimized
                      ? "maximizeAttributes"
                      : "minimizeAttributes"
                  )
                },
              },
            },
            [
              _c("fa", {
                attrs: {
                  icon: [
                    "fas",
                    _vm.attributesMinimized
                      ? "window-maximize"
                      : "window-minimize",
                  ],
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "att-icon-btn att-close",
              attrs: { type: "button", title: "Close", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.closeAttTable()
                },
              },
            },
            [_c("fa", { attrs: { icon: ["fas", "times"] } })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.attributesMinimized,
              expression: "!attributesMinimized",
            },
          ],
          staticClass: "att-body scroll-Container",
        },
        _vm._l(_vm.attribResponse, function (resp, index) {
          return _c("div", { key: index, staticClass: "att-row" }, [
            _c("div", { staticClass: "att-name" }, [_vm._v(_vm._s(resp.name))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "att-value",
                attrs: { id: "editor" + index, title: "Copy value" },
                on: {
                  click: function ($event) {
                    return _vm.copyText(resp.value)
                  },
                },
              },
              [
                _c("span", { staticClass: "att-value-text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        resp.name == "created_date" ||
                          resp.name == "updated_date"
                          ? resp.value
                            ? resp.value.replace("Z", "")
                            : resp.value
                          : resp.value
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("fa", {
                  staticClass: "att-copy-icon",
                  attrs: { icon: ["fas", "copy"] },
                }),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.attributesMinimized,
              expression: "!attributesMinimized",
            },
          ],
          staticClass: "att-footer",
        },
        [
          _c("div", { staticClass: "att-pager" }, [
            _c(
              "button",
              {
                staticClass: "att-pager-btn",
                attrs: { type: "button", disabled: _vm.feature_index < 1 },
                on: {
                  click: function ($event) {
                    return _vm.getNextFeature(-1)
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "chevron-left"] } })],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "att-pager-count" }, [
              _vm._v(
                _vm._s(_vm.feature_index + 1) +
                  " of " +
                  _vm._s(_vm.features.length)
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "att-pager-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.feature_index + 1 >= _vm.features.length,
                },
                on: {
                  click: function ($event) {
                    return _vm.getNextFeature(1)
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "chevron-right"] } })],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "close-btn",
              on: {
                click: function ($event) {
                  return _vm.closeAttTable()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }